import classNames from "classnames";
import { menuIcon } from "./styles.css";

export const MenuIcon = ({
  className,
  style,
  isTransformed,
}: StyledProps & { isTransformed?: boolean }) => {
  return (
    <svg
      className={classNames(
        isTransformed ? menuIcon.transformed : menuIcon.default,
        className
      )}
      style={style}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        id="top-bar"
        x="4"
        y="9.82031"
        width="24"
        height="3.93"
        fill="currentColor"
      />
      <rect
        id="bottom-bar"
        x="4"
        y="18.25"
        width="24"
        height="3.93"
        fill="currentColor"
      />
    </svg>
  );
};
